import React, { useEffect, useState } from 'react';

import { Button } from 'js/components/common/Button';
import { LocalPopup } from 'js/components/common/Popup';
import { WebContentInner } from 'js/components/system/WebContent';

import { storageService } from 'js/services/storage.service';
import { useGetWebContentData } from 'js/app/components/system/WebContent/hooks/useGetWebContentData';

import { useOldBrowser } from './hooks';

import style from './OldBrowserMessagePopup.scss';

export const OldBrowserMessagePopup = () => {
    const [isShow, setIsShow] = useState();
    const { articleId, button } = useOldBrowser();
    const { state: { isLoading, data } } = useGetWebContentData({
        id: !storageService.local.getItem('isShowedOldBrowserMessage') && articleId
    });

    useEffect(() => {
        if (!isLoading && data) {
            setIsShow(true);
            storageService.local.setItem('isShowedOldBrowserMessage', true);
        }
    }, [data, isLoading]);

    const closePopup = () => {
        setIsShow(false);
    };

    if (!isShow) {
        return null;
    }

    return (
        <LocalPopup onClose={closePopup}>
            <WebContentInner content={data} />

            <Button
                className={style.button}
                view='secondary'
                href={button.action}
                onClick={closePopup}
            >
                {button.title}
            </Button>
        </LocalPopup>
    );
};
